import { findIndex, noop, reduce } from 'lodash/fp';

export default ({ items, id, mutator = noop } = {}) => {
  const index = findIndex({ id }, items);

  if (index > -1) {
    return reduce(
      (acc, item) => {
        if (item.id === id) {
          const mutatedItem = mutator(item);

          return [...acc, mutatedItem];
        }

        return [...acc, item];
      },
      [],
      items,
    );
  }

  return items;
};
